import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FaHubspot } from "react-icons/fa6";
import "./BusinessHub.css";

export default function BusinessHub(props) {
  return (
    <div>
      <Container>
        <Row>
          <Col className="business-hub-first-col">
            <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
              <FaHubspot
                style={{ color: props.iconColor }}
                className="business-hub-icon"
              />
              NOSSAS EMPRESAS
            </h2>
          </Col>
        </Row>
        <Row>
          <Col className="business-hub-second-col">
            <p style={{ color: props.textColor, fontSize: props.textSize }}>
              Há mais de 100 anos valorizando a vida com serviços que respeitam
              o ser humano.
            </p>
          </Col>
        </Row>
      </Container>
      <Container className="business-hub-container">
        <div className="business-hub-overlay" />
        <Row className="business-hub-first-row">
          <Col md="6" className="business-hub-third-col">
            <Link
              to="/servicos/krause-assistencial/"
              className="business-link-ka"
            />
          </Col>
          <Col md="6" className="business-hub-fourth-col">
            <Link
              to="/servicos/memorial-krause/"
              className="business-link-mk"
            />
          </Col>
        </Row>
        <Row className="business-hub-second-row">
          <Col md="6" className="business-hub-fifty-col">
            <Link
              to="/servicos/funeraria-krause/"
              className="business-link-fk"
            />
          </Col>
          <Col md="6" className="business-hub-sixth-col">
            <Link to="/servicos/mais-que-pet/" className="business-link-pet" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
